import React, { Component } from "react";
import eyLogoImg from "../../assets/images/logo1.png";
import { Collapse } from "react-bootstrap";
import { connect } from "react-redux";
import cx from "classnames";
import { Link, withRouter } from "react-router-dom";
import * as Business from "../../utils/business";
import UpdatePassword from "../../pages/User/UpdatePassword";
import * as Http from "../../http";

class VersionInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      bizVersion: "",
      webVersion: "24.0730.0800",
    };
    this.getVersion = this.getVersion.bind(this);
  }

  componentDidMount() {
    this.getVersion();
  }

  getVersion = () => {
    this.setState(
      {
        bizVersion: "",
        loading: true,
      },
      () => {
        Http.getVersion().then((res) => {
          if (res && res.Success) {
            if (res.Data) {
              this.setState({
                bizVersion: res.Data ? res.Data : "",
                loading: false,
              });
            }
          }
        });
      },
    );
  };

  render() {
    return (
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          textAlign: "center",
          paddingBottom: "8px",
        }}
      >
        <div style={{ marginBottom: "4px" }}>
          <img
            src={eyLogoImg}
            alt="EY"
            style={{ height: 40, width: "auto", opacity: 0.85 }}
          />
        </div>
        <div
          style={{ color: "#8d8d8d", fontSize: "9px", letterSpacing: "0.02em" }}
        >
          <span>
            v{this.state.bizVersion} # {this.state.webVersion}
          </span>
        </div>
      </div>
    );
  }
}

export default VersionInfo;



// WEBPACK FOOTER //
// src/components/SideBar/VersionInfo.js